import { app } from '../../app.module'
app
  // アカウントの高く評価グラフの表示
  .directive('accountLike', () => {
    return {
      restrict: 'E',
      template: require('./account-like.pug')(),
    }
  })
